import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  ManyToOne,
  JoinColumn,
} from 'typeorm';
import { IsOptional, IsInt } from 'class-validator';

import { Internacao } from './Internacao';
import { Paciente } from './Paciente';
import { Usuario } from './Usuario';
import { TipoInformacaoParto } from '../types';

@Entity({ name: 'informacoes_partos' })
export class InformacaoParto {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsInt()
  paciente_id: number;

  @Column()
  @IsInt()
  @IsOptional()
  internacao_id: number | null;

  @Column({
    type: 'enum',
    enum: TipoInformacaoParto,
  })
  tipo: string | null;

  @Column()
  @IsOptional()
  datetime_informacao?: Date | null;

  @Column()
  @IsOptional()
  datetime_cancelamento?: Date | null;

  @Column()
  @IsOptional()
  justificativa_cancelamento?: string | null;

  @Column()
  @IsOptional()
  observacoes?: string | null;

  @Column()
  @IsOptional()
  responsavel_id?: number | null;

  @CreateDateColumn()
  @IsOptional()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  @IsOptional()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  @ManyToOne(() => Paciente)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;

  @ManyToOne(() => Internacao)
  @JoinColumn({ name: 'internacao_id' })
  internacao?: Internacao;

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'responsavel_id' })
  responsavel?: Usuario;

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'updated_by' })
  usuario_updated_by?: Usuario;
}
